import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import DonationSuccess from './pages/DonationSuccess';
import ProjectPage from './pages/ProjectPage';
import NewsPage from './pages/NewsPage';
import NewsIndexPage from './pages/NewsIndexPage';
import AnnualReportsPage from './pages/AnnualReportsPage';
import BranchesPage from './pages/BranchesPage';
import RoomBookingPage from './pages/RoomBookingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Header from './components/Header';
import AnnouncementBanner from './components/AnnouncementBanner';
import Hero from './components/Hero';
import About from './components/About';
import Programmes from './components/Programmes';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Videos from './components/Videos';
import Events from './components/Events';
import DonationQR from './components/DonationQR';
import Contact from './components/Contact';
import Sitemap from './components/Sitemap';
import Branches from './components/Branches';
import Partners from './components/Partners';
import CTA from './components/CTA';
import Careers from './components/Careers';
import Footer from './components/Footer';
import FloatingDonate from './components/FloatingDonate';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ChatWidget from './components/ChatWidget';
import { LiveVisitors } from './components/LiveVisitors';
import SocialProofToast from './components/SocialProofToast';
import LaunchOverlay from './components/LaunchOverlay';
import { Toaster } from './components/ui/toaster';
import { I18nProvider } from './i18n/I18nProvider';
import SiteLaunchGate from './components/SiteLaunchGate';
import './App.css';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <AnnouncementBanner />
      <Hero />
      <About />
      <Programmes />
      <Testimonials />
      <Gallery />
      <Videos />
      <Events />
      <Careers />
      <DonationQR />
      <Contact />
      <Sitemap />
      <Partners />
      <CTA />
      <Footer />
      <FloatingDonate />
      <FloatingWhatsApp />
      <ChatWidget />
      <LiveVisitors />
      <SocialProofToast />
      <LaunchOverlay />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <SiteLaunchGate>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/donate/success" element={<DonationSuccess />} />
              <Route path="/projects/:slug" element={<ProjectPage />} />
              <Route path="/news" element={<NewsIndexPage />} />
              <Route path="/news/:section" element={<NewsPage />} />
              <Route path="/branches" element={<BranchesPage />} />
              <Route path="/annual-reports" element={<AnnualReportsPage />} />
              <Route path="/room-booking" element={<RoomBookingPage />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsConditions />} />
            </Routes>
          </BrowserRouter>
        </SiteLaunchGate>
        <Toaster />
      </I18nProvider>
    </div>
  );
}

export default App;
